import React from 'react';

import { Button } from '../../../components/MuiGenerals';
import { useTranslation } from '../../../hooks';

interface IProps {
  onClick: () => void;
}

const RejectButton = ({ onClick }: IProps) => {
  const { tc } = useTranslation();

  return (
    <Button
      className={'inheritColor'}
      color={'primary'}
      variant={'contained'}
      children={tc('reject_btn')}
      onClick={onClick}
      style={{
        width: '160px',
        height: '38px',
        marginRight: '12px',
        backgroundColor: '#E86A62',
        color: '#FFFFFF',
        borderRadius: '8px',
      }}
    />
  );
};

export default RejectButton;
